module.exports = __webpack_public_path__ + "media/src/images/icons/note_book-37375979a27651ed8a36ce2dbcb1f7d8.svg";